export interface Chapter {
  id: string;
  title: string;
  number: number;
  updatedAt: string;
  isFree: boolean;
}

export interface Comic {
  id: string;
  title: string;
  author: string;
  cover: string;
  description: string;
  category: string;
  categorySlug: string;
  tags: string[];
  status: string;
  rating: number;
  views: number;
  favorites: number;
  chapters: Chapter[];
  updatedAt: string;
  isHot: boolean;
  isNew: boolean;
  isFree: boolean;
}

export interface Category {
  slug: string;
  name: string;
  icon: string;
}

export const categories: Category[] = [
  { slug: 'all', name: '全部', icon: 'ri-apps-line' },
  { slug: 'romance', name: '恋爱', icon: 'ri-heart-line' },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line' },
  { slug: 'action', name: '动作', icon: 'ri-flashlight-line' },
  { slug: 'comedy', name: '搞笑', icon: 'ri-emotion-laugh-line' },
  { slug: 'thriller', name: '悬疑', icon: 'ri-search-eye-line' },
  { slug: 'drama', name: '剧情', icon: 'ri-film-line' },
  { slug: 'daily', name: '日常', icon: 'ri-sun-line' },
];

export const comics: Comic[] = [
  {
    id: 'comic-001',
    title: '她的秘密花园',
    author: '金秀贤',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20style%20illustration%20of%20a%20young%20woman%20in%20a%20secret%20garden%20with%20flowers%2C%20soft%20romantic%20atmosphere%2C%20pastel%20colors%2C%20digital%20art%2C%20webtoon%20cover%20style%2C%20clean%20composition%2C%20warm%20lighting&width=400&height=560&seq=comic-cover-001&orientation=portrait',
    description: '因为一次意外，她发现自己居然能听到植物说话。那个总是板着脸的邻居家院子里，一朵玫瑰悄悄告诉她一个惊人的秘密...从此，她的平凡生活彻底改变。',
    category: '恋爱',
    categorySlug: 'romance',
    tags: ['恋爱', '奇幻', '日常'],
    status: '连载中',
    rating: 9.2,
    views: 1280000,
    favorites: 86000,
    chapters: [
      { id: 'ch-001-1', title: '第1话 意外的开始', number: 1, updatedAt: '2026-08-01', isFree: true },
      { id: 'ch-001-2', title: '第2话 玫瑰的秘密', number: 2, updatedAt: '2026-08-02', isFree: true },
      { id: 'ch-001-3', title: '第3话 邻居的真相', number: 3, updatedAt: '2026-08-03', isFree: true },
      { id: 'ch-001-4', title: '第4话 花园的低语', number: 4, updatedAt: '2026-08-03', isFree: false },
      { id: 'ch-001-5', title: '第5话 改变的开始', number: 5, updatedAt: '2026-08-04', isFree: false },
      { id: 'ch-001-6', title: '第6话 新的世界', number: 6, updatedAt: '2026-08-04', isFree: false },
      { id: 'ch-001-7', title: '第7话 不速之客', number: 7, updatedAt: '2026-08-05', isFree: false },
      { id: 'ch-001-8', title: '第8话 隐藏的线索', number: 8, updatedAt: '2026-08-05', isFree: false },
    ],
    updatedAt: '2026-08-05',
    isHot: true,
    isNew: false,
    isFree: true,
  },
  {
    id: 'comic-002',
    title: '剑与魔法学院',
    author: '李智慧',
    cover: 'https://readdy.ai/api/search-image?query=A%20fantasy%20Korean%20manhwa%20style%20illustration%20of%20a%20magic%20academy%20student%20holding%20a%20glowing%20sword%2C%20heroic%20pose%2C%20dramatic%20lighting%2C%20epic%20fantasy%20background%2C%20digital%20art%2C%20webtoon%20cover%20style%2C%20clean%20composition&width=400&height=560&seq=comic-cover-002&orientation=portrait',
    description: '在所有人都认为他是废柴的时候，一把神秘的剑选择了他。从此他进入了隐藏在世界背后的魔法学院，踏上了一条充满冒险与成长的旅程。',
    category: '奇幻',
    categorySlug: 'fantasy',
    tags: ['奇幻', '动作', '学院'],
    status: '连载中',
    rating: 9.5,
    views: 2150000,
    favorites: 152000,
    chapters: [
      { id: 'ch-002-1', title: '第1话 废柴的日常', number: 1, updatedAt: '2026-07-28', isFree: true },
      { id: 'ch-002-2', title: '第2话 神秘之剑', number: 2, updatedAt: '2026-07-29', isFree: true },
      { id: 'ch-002-3', title: '第3话 入学考试', number: 3, updatedAt: '2026-07-30', isFree: true },
      { id: 'ch-002-4', title: '第4话 第一堂课', number: 4, updatedAt: '2026-08-01', isFree: false },
      { id: 'ch-002-5', title: '第5话 地下迷宫', number: 5, updatedAt: '2026-08-02', isFree: false },
      { id: 'ch-002-6', title: '第6话 强敌出现', number: 6, updatedAt: '2026-08-03', isFree: false },
    ],
    updatedAt: '2026-08-03',
    isHot: true,
    isNew: false,
    isFree: false,
  },
  {
    id: 'comic-003',
    title: '都市猎人传说',
    author: '朴宰范',
    cover: 'https://readdy.ai/api/search-image?query=A%20dark%20action%20Korean%20manhwa%20style%20illustration%20of%20a%20vigilante%20in%20a%20city%20at%20night%2C%20wearing%20a%20mask%2C%20rainy%20urban%20street%2C%20neo-noir%20atmosphere%2C%20tense%20mood%2C%20digital%20art%2C%20webtoon%20cover%20style%2C%20clean%20composition&width=400&height=560&seq=comic-cover-003&orientation=portrait',
    description: '白天是普通上班族，夜晚则化身都市传说中的猎人。他用正义的铁拳惩罚那些逃脱法律制裁的罪犯，但这一次，他发现了一个牵连到最高层的惊天阴谋。',
    category: '动作',
    categorySlug: 'action',
    tags: ['动作', '悬疑', '都市'],
    status: '连载中',
    rating: 9.3,
    views: 1890000,
    favorites: 120000,
    chapters: [
      { id: 'ch-003-1', title: '第1话 平凡的一天', number: 1, updatedAt: '2026-07-25', isFree: true },
      { id: 'ch-003-2', title: '第2话 深夜追踪', number: 2, updatedAt: '2026-07-26', isFree: true },
      { id: 'ch-003-3', title: '第3话 第一次出手', number: 3, updatedAt: '2026-07-28', isFree: true },
      { id: 'ch-003-4', title: '第4话 面具之下', number: 4, updatedAt: '2026-07-30', isFree: false },
      { id: 'ch-003-5', title: '第5话 阴谋浮现', number: 5, updatedAt: '2026-08-01', isFree: false },
    ],
    updatedAt: '2026-08-01',
    isHot: true,
    isNew: false,
    isFree: false,
  },
  {
    id: 'comic-004',
    title: '笑傲便利店',
    author: '郑多恩',
    cover: 'https://readdy.ai/api/search-image?query=A%20funny%20Korean%20manhwa%20style%20illustration%20of%20quirky%20convenience%20store%20employees%2C%20colorful%20snack%20aisles%2C%20comedy%20expressions%2C%20bright%20and%20cheerful%20colors%2C%20digital%20art%2C%20webtoon%20cover%20style%2C%20clean%20composition&width=400&height=560&seq=comic-cover-004&orientation=portrait',
    description: '24小时便利店里，一群性格迥异的兼职生上演着啼笑皆非的日常喜剧。从深夜的奇葩顾客到白天的混乱时刻，这里每天都有新的笑料诞生。',
    category: '搞笑',
    categorySlug: 'comedy',
    tags: ['搞笑', '日常', '职场'],
    status: '连载中',
    rating: 9.0,
    views: 980000,
    favorites: 72000,
    chapters: [
      { id: 'ch-004-1', title: '第1话 第一天上班', number: 1, updatedAt: '2026-08-01', isFree: true },
      { id: 'ch-004-2', title: '第2话 奇葩顾客一号', number: 2, updatedAt: '2026-08-02', isFree: true },
      { id: 'ch-004-3', title: '第3话 夜班的恐怖', number: 3, updatedAt: '2026-08-03', isFree: true },
      { id: 'ch-004-4', title: '第4话 仓库大作战', number: 4, updatedAt: '2026-08-04', isFree: false },
    ],
    updatedAt: '2026-08-04',
    isHot: false,
    isNew: true,
    isFree: false,
  },
  {
    id: 'comic-005',
    title: '消失的第七人',
    author: '姜志成',
    cover: 'https://readdy.ai/api/search-image?query=A%20mystery%20thriller%20Korean%20manhwa%20style%20illustration%20of%20seven%20people%20in%20a%20dimly%20lit%20room%20with%20one%20shadow%20missing%2C%20tense%20atmosphere%2C%20cold%20blue%20tones%2C%20digital%20art%2C%20webtoon%20cover%20style%2C%20clean%20composition&width=400&height=560&seq=comic-cover-005&orientation=portrait',
    description: '七个人被困在一座与世隔绝的别墅中，但第七个人却在第一天晚上神秘消失了。剩下的人必须找出真相，因为每过一晚，就会少一个人。',
    category: '悬疑',
    categorySlug: 'thriller',
    tags: ['悬疑', '推理', '恐怖'],
    status: '连载中',
    rating: 9.4,
    views: 1560000,
    favorites: 98000,
    chapters: [
      { id: 'ch-005-1', title: '第1话 七人聚会', number: 1, updatedAt: '2026-08-02', isFree: true },
      { id: 'ch-005-2', title: '第2话 第一个夜晚', number: 2, updatedAt: '2026-08-03', isFree: true },
      { id: 'ch-005-3', title: '第3话 怀疑的种子', number: 3, updatedAt: '2026-08-04', isFree: false },
      { id: 'ch-005-4', title: '第4话 第二个失踪者', number: 4, updatedAt: '2026-08-05', isFree: false },
    ],
    updatedAt: '2026-08-05',
    isHot: true,
    isNew: false,
    isFree: false,
  },
  {
    id: 'comic-006',
    title: '重生之商业帝国',
    author: '尹恩惠',
    cover: 'https://readdy.ai/api/search-image?query=A%20drama%20Korean%20manhwa%20style%20illustration%20of%20a%20confident%20businessman%20in%20a%20luxury%20office%20overlooking%20the%20city%2C%20power%20and%20ambition%20theme%2C%20sophisticated%20color%20palette%2C%20digital%20art%2C%20webtoon%20cover%20style%2C%20clean%20composition&width=400&height=560&seq=comic-cover-006&orientation=portrait',
    description: '被最信任的人背叛，他从商业帝国的顶端跌入深渊。命运给了他第二次机会，带着前世的记忆重生，这一次他要改写一切，打造属于自己的真正帝国。',
    category: '剧情',
    categorySlug: 'drama',
    tags: ['剧情', '重生', '商战'],
    status: '连载中',
    rating: 9.6,
    views: 3200000,
    favorites: 210000,
    chapters: [
      { id: 'ch-006-1', title: '第1话 背叛之夜', number: 1, updatedAt: '2026-07-20', isFree: true },
      { id: 'ch-006-2', title: '第2话 回到过去', number: 2, updatedAt: '2026-07-22', isFree: true },
      { id: 'ch-006-3', title: '第3话 新的开始', number: 3, updatedAt: '2026-07-24', isFree: true },
      { id: 'ch-006-4', title: '第4话 第一桶金', number: 4, updatedAt: '2026-07-26', isFree: false },
      { id: 'ch-006-5', title: '第5话 商场如战场', number: 5, updatedAt: '2026-07-28', isFree: false },
      { id: 'ch-006-6', title: '第6话 旧敌重逢', number: 6, updatedAt: '2026-07-30', isFree: false },
      { id: 'ch-006-7', title: '第7话 逆袭开始', number: 7, updatedAt: '2026-08-02', isFree: false },
      { id: 'ch-006-8', title: '第8话 帝国雏形', number: 8, updatedAt: '2026-08-04', isFree: false },
    ],
    updatedAt: '2026-08-04',
    isHot: true,
    isNew: false,
    isFree: false,
  },
  {
    id: 'comic-007',
    title: '咖啡与猫的日常',
    author: '宋智雅',
    cover: 'https://readdy.ai/api/search-image?query=A%20cozy%20slice-of-life%20Korean%20manhwa%20style%20illustration%20of%20a%20girl%20with%20a%20cat%20in%20a%20warm%20cafe%2C%20soft%20sunlight%2C%20relaxing%20vibe%2C%20warm%20tones%2C%20digital%20art%2C%20webtoon%20cover%20style%2C%20clean%20composition&width=400&height=560&seq=comic-cover-007&orientation=portrait',
    description: '刚毕业的女孩在一家小咖啡馆找到了工作，还收养了一只流浪猫。温馨的日常中，她遇见了形形色色的人和故事，也慢慢找到了自己生活的方向。',
    category: '日常',
    categorySlug: 'daily',
    tags: ['日常', '治愈', '美食'],
    status: '已完结',
    rating: 8.9,
    views: 750000,
    favorites: 58000,
    chapters: [
      { id: 'ch-007-1', title: '第1话 流浪猫', number: 1, updatedAt: '2026-06-01', isFree: true },
      { id: 'ch-007-2', title: '第2话 第一天上班', number: 2, updatedAt: '2026-06-05', isFree: true },
      { id: 'ch-007-3', title: '第3话 拿铁拉花', number: 3, updatedAt: '2026-06-10', isFree: true },
      { id: 'ch-007-4', title: '第4话 常客的故事', number: 4, updatedAt: '2026-06-15', isFree: false },
      { id: 'ch-007-5', title: '第5话 雨天的相遇', number: 5, updatedAt: '2026-06-20', isFree: false },
      { id: 'ch-007-6', title: '第6话 新的开始（完）', number: 6, updatedAt: '2026-06-25', isFree: false },
    ],
    updatedAt: '2026-06-25',
    isHot: false,
    isNew: false,
    isFree: true,
  },
  {
    id: 'comic-008',
    title: '魔王大人想休假',
    author: '崔贤宇',
    cover: 'https://readdy.ai/api/search-image?query=A%20comedy%20fantasy%20Korean%20manhwa%20style%20illustration%20of%20a%20demon%20king%20in%20casual%20vacation%20clothes%20looking%20exhausted%20at%20a%20beach%2C%20contrast%20between%20dark%20lord%20and%20relaxing%20scene%2C%20funny%20vibe%2C%20digital%20art%2C%20webtoon%20cover%20style%2C%20clean%20composition&width=400&height=560&seq=comic-cover-008&orientation=portrait',
    description: '统治魔界三千年的魔王终于受够了。他决定给自己放个长假，偷偷跑到人类世界度假。然而人类的日常生活远比管理魔界更加艰难——尤其是当他不会用自动售货机的时候。',
    category: '搞笑',
    categorySlug: 'comedy',
    tags: ['搞笑', '奇幻', '日常'],
    status: '连载中',
    rating: 9.1,
    views: 1120000,
    favorites: 85000,
    chapters: [
      { id: 'ch-008-1', title: '第1话 我要休假', number: 1, updatedAt: '2026-08-01', isFree: true },
      { id: 'ch-008-2', title: '第2话 人类世界初体验', number: 2, updatedAt: '2026-08-02', isFree: true },
      { id: 'ch-008-3', title: '第3话 自动售货机的挑战', number: 3, updatedAt: '2026-08-03', isFree: true },
      { id: 'ch-008-4', title: '第4话 便利店大冒险', number: 4, updatedAt: '2026-08-04', isFree: false },
      { id: 'ch-008-5', title: '第5话 魔界来电', number: 5, updatedAt: '2026-08-05', isFree: false },
    ],
    updatedAt: '2026-08-05',
    isHot: false,
    isNew: true,
    isFree: false,
  },
  {
    id: 'comic-009',
    title: '命运的红线',
    author: '金秀贤',
    cover: 'https://readdy.ai/api/search-image?query=A%20romantic%20Korean%20manhwa%20style%20illustration%20of%20a%20couple%20connected%20by%20a%20red%20thread%20of%20fate%2C%20cherry%20blossom%20background%2C%20soft%20pink%20tones%2C%20dreamy%20atmosphere%2C%20digital%20art%2C%20webtoon%20cover%20style%2C%20clean%20composition&width=400&height=560&seq=comic-cover-009&orientation=portrait',
    description: '她从小就能看到连接人与人的红线，却唯独看不到自己的。直到那天，一个陌生的转校生走进教室，她的手心里第一次出现了红色的丝线。',
    category: '恋爱',
    categorySlug: 'romance',
    tags: ['恋爱', '奇幻', '校园'],
    status: '已完结',
    rating: 9.3,
    views: 1780000,
    favorites: 135000,
    chapters: [
      { id: 'ch-009-1', title: '第1话 看不见的红线', number: 1, updatedAt: '2026-05-01', isFree: true },
      { id: 'ch-009-2', title: '第2话 转校生', number: 2, updatedAt: '2026-05-08', isFree: true },
      { id: 'ch-009-3', title: '第3话 第一次触碰', number: 3, updatedAt: '2026-05-15', isFree: true },
      { id: 'ch-009-4', title: '第4话 命运的齿轮', number: 4, updatedAt: '2026-05-22', isFree: false },
      { id: 'ch-009-5', title: '第5话 交错的心', number: 5, updatedAt: '2026-05-29', isFree: false },
      { id: 'ch-009-6', title: '第6话 真相', number: 6, updatedAt: '2026-06-05', isFree: false },
      { id: 'ch-009-7', title: '第7话 永远的约定（完）', number: 7, updatedAt: '2026-06-12', isFree: false },
    ],
    updatedAt: '2026-06-12',
    isHot: false,
    isNew: false,
    isFree: true,
  },
  {
    id: 'comic-010',
    title: '武林第一高手在现代',
    author: '韩在石',
    cover: 'https://readdy.ai/api/search-image?query=A%20martial%20arts%20action%20Korean%20manhwa%20style%20illustration%20of%20a%20traditional%20warrior%20in%20modern%20city%20street%2C%20clash%20of%20ancient%20and%20modern%2C%20dynamic%20pose%2C%20dramatic%20lighting%2C%20digital%20art%2C%20webtoon%20cover%20style%2C%20clean%20composition&width=400&height=560&seq=comic-cover-010&orientation=portrait',
    description: '天下第一高手在渡劫时出了意外，一觉醒来发现自己穿越到了现代。没有内力但有WiFi，没有轻功但有地铁。当古代武林绝学遇上现代都市，一场啼笑皆非的冒险开始了。',
    category: '动作',
    categorySlug: 'action',
    tags: ['动作', '搞笑', '穿越'],
    status: '连载中',
    rating: 9.4,
    views: 2010000,
    favorites: 145000,
    chapters: [
      { id: 'ch-010-1', title: '第1话 渡劫失败', number: 1, updatedAt: '2026-07-30', isFree: true },
      { id: 'ch-010-2', title: '第2话 现代震撼', number: 2, updatedAt: '2026-08-01', isFree: true },
      { id: 'ch-010-3', title: '第3话 第一次坐地铁', number: 3, updatedAt: '2026-08-02', isFree: true },
      { id: 'ch-010-4', title: '第4话 街头风波', number: 4, updatedAt: '2026-08-03', isFree: false },
      { id: 'ch-010-5', title: '第5话 地下格斗场', number: 5, updatedAt: '2026-08-04', isFree: false },
      { id: 'ch-010-6', title: '第6话 高手对决', number: 6, updatedAt: '2026-08-05', isFree: false },
    ],
    updatedAt: '2026-08-05',
    isHot: true,
    isNew: false,
    isFree: false,
  },
  {
    id: 'comic-011',
    title: '面试地狱',
    author: '郑多恩',
    cover: 'https://readdy.ai/api/search-image?query=A%20satirical%20comedy%20Korean%20manhwa%20style%20illustration%20of%20job%20seekers%20in%20a%20ridiculous%20interview%20scene%2C%20exaggerated%20expressions%2C%20corporate%20satire%2C%20bright%20colors%2C%20digital%20art%2C%20webtoon%20cover%20style%2C%20clean%20composition&width=400&height=560&seq=comic-cover-011&orientation=portrait',
    description: '职场新人朴志浩的求职之路充满坎坷。从奇葩面试官到离谱的笔试题目，他经历了你能想象到的一切求职噩梦——但这次，他决定不再忍耐。',
    category: '搞笑',
    categorySlug: 'comedy',
    tags: ['搞笑', '职场', '日常'],
    status: '连载中',
    rating: 8.8,
    views: 680000,
    favorites: 42000,
    chapters: [
      { id: 'ch-011-1', title: '第1话 第一百次投简历', number: 1, updatedAt: '2026-08-03', isFree: true },
      { id: 'ch-011-2', title: '第2话 奇怪的面试官', number: 2, updatedAt: '2026-08-04', isFree: true },
      { id: 'ch-011-3', title: '第3话 AI面试', number: 3, updatedAt: '2026-08-05', isFree: false },
    ],
    updatedAt: '2026-08-05',
    isHot: false,
    isNew: true,
    isFree: false,
  },
  {
    id: 'comic-012',
    title: '深海迷踪',
    author: '姜志成',
    cover: 'https://readdy.ai/api/search-image?query=A%20deep%20sea%20thriller%20Korean%20manhwa%20style%20illustration%20of%20a%20submarine%20in%20dark%20ocean%20depths%20with%20mysterious%20glowing%20creatures%2C%20cold%20atmosphere%2C%20sense%20of%20isolation%2C%20digital%20art%2C%20webtoon%20cover%20style%2C%20clean%20composition&width=400&height=560&seq=comic-cover-012&orientation=portrait',
    description: '深海科考队在马里亚纳海沟发现了一座不应该存在的建筑。当他们靠近调查时，通讯突然中断，潜水器失去了控制。在深不见底的黑暗中，有什么东西在注视着他们。',
    category: '悬疑',
    categorySlug: 'thriller',
    tags: ['悬疑', '科幻', '冒险'],
    status: '连载中',
    rating: 9.5,
    views: 1670000,
    favorites: 108000,
    chapters: [
      { id: 'ch-012-1', title: '第1话 深海任务', number: 1, updatedAt: '2026-08-01', isFree: true },
      { id: 'ch-012-2', title: '第2话 异常信号', number: 2, updatedAt: '2026-08-02', isFree: true },
      { id: 'ch-012-3', title: '第3话 深渊之下', number: 3, updatedAt: '2026-08-03', isFree: false },
      { id: 'ch-012-4', title: '第4话 失联', number: 4, updatedAt: '2026-08-05', isFree: false },
    ],
    updatedAt: '2026-08-05',
    isHot: false,
    isNew: true,
    isFree: false,
  },
];

export const freeComics = comics.filter(c => c.isFree);

export const hotComics = comics.filter(c => c.isHot);

export const newComics = comics.filter(c => c.isNew);

export const getComicsByCategory = (slug: string) => {
  if (slug === 'all') return comics;
  return comics.filter(c => c.categorySlug === slug);
};

export const getComicById = (id: string) => {
  return comics.find(c => c.id === id);
};